import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { Pill } from '@els/els-react--pill';
import SummaryTrailingActions from '@Containers/Summary/components/SummaryTrailingActions';

export default function FilterAppliedNudge({
  appliedFilter,
  className,
  onDismiss,
  onSummarizeTop,
  onSummarizeSelected,
  primaryActionRef,
  selectionError,
}) {
  if (!appliedFilter) {
    return null;
  }

  const actionLabel = appliedFilter.action === 'EXCLUDE' ? 'Exclude:' : 'Limit to:';
  const actions = [
    {
      buttonRef: primaryActionRef,
      dataE2e: 'summarize-results-button',
      label: 'Summarise results',
      onClick: onSummarizeTop,
      type: 'primary',
    },
    {
      dataE2e: 'summarize-selected-results-button',
      isSelectionAction: true,
      label: 'Summarise selected results',
      onClick: onSummarizeSelected,
      type: selectionError ? 'warn' : 'secondary',
    },
  ];

  return (
    <SummaryTrailingActions
      actions={actions}
      ariaLive="polite"
      className={className}
      role="status"
      selectionError={selectionError}
      testId="filter-applied-nudge">
      <div className="filter-applied-summary">
        <div className="filter-applied-summary__message">
          <p>You narrowed your results to {appliedFilter.resultCount} using these filters:</p>
          <ButtonWithIcon
            type="borderless"
            size="x-small"
            sprite="Close"
            iconRight
            iconOnly
            aria-label="Dismiss assistant prompt"
            data-e2e="dismiss-filter-applied-summary"
            className="filter-applied-summary__dismiss"
            onClick={onDismiss}>
            Dismiss assistant prompt
          </ButtonWithIcon>
        </div>
        <div className="filter-applied-summary__filters">
          <p className="u-els-font-family-bold">{actionLabel}</p>
          <div className="filter-applied-summary__pills">
            {appliedFilter.categories.map(({ label, count }) => (
              <Pill key={label} pillColor="extended-blue-1" textColor="text">
                {`${label} · ${count}`}
              </Pill>
            ))}
          </div>
        </div>
        <p>Would you like a summary of these results?</p>
      </div>
    </SummaryTrailingActions>
  );
}

FilterAppliedNudge.propTypes = {
  appliedFilter: PropTypes.shape({
    action: PropTypes.oneOf(['LIMIT', 'EXCLUDE']).isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired, count: PropTypes.number.isRequired })).isRequired,
    resultCount: PropTypes.number.isRequired,
    resultName: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  onSummarizeTop: PropTypes.func.isRequired,
  onSummarizeSelected: PropTypes.func.isRequired,
  primaryActionRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  selectionError: PropTypes.string,
};
